







import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  components: {}
})
class JobEmploymentPositionResourceItem2JobPositionStatistics extends Vue {

}

export default JobEmploymentPositionResourceItem2JobPositionStatistics


